import { useEffect, useState } from "react";

import DOMPurify from "dompurify";
import _ from "lodash";
import { sanitizeAndPrepareEmailDescription } from "../utils/utils";

const useUpdateChangesCount = (
  formMethods: any,
  initialValues: any,
  event: any,
  eventLoading: boolean
) => {
  const [changesCount, setChangesCount] = useState(0);

  useEffect(() => {
    if (eventLoading) {
      return;
    }
    const updateChangesCount = () => {
      const data = formMethods.getValues();
      let newChangesCount = Object.keys(initialValues).reduce(
        (count: number, key: string) => {
          const keyAsString = key as keyof typeof initialValues;

          if (keyAsString === "description") {
            const initialDescription = initialValues[keyAsString] as string;
            const currentDescription = data[keyAsString] as string;

            let currentDescriptionString = `${DOMPurify.sanitize(
              currentDescription
            )}`;

            if (initialDescription === currentDescriptionString) {
              return count;
            }

            currentDescriptionString = sanitizeAndPrepareEmailDescription(
              currentDescriptionString
            );

            if (!_.isEqual(initialDescription, currentDescriptionString)) {
              return count + 1;
            } else {
              return count;
            }
          }

          if (keyAsString === "recipientList") {
            const initialRecipientList = initialValues[keyAsString] as string[];
            const currentRecipientList = data[keyAsString] as string[];

            if (!_.isEqual(initialRecipientList, currentRecipientList)) {
              return count + 1;
            }
          }

          if (
            keyAsString !== "eventImageFile" &&
            !_.isEqual(data[keyAsString], initialValues[keyAsString])
          ) {
            return count + 1;
          }

          return count;
        },
        0
      );

      if (newChangesCount !== changesCount) {
        setChangesCount(newChangesCount);
      }
    };

    const subscription = formMethods.watch(() => updateChangesCount());
    return () => subscription.unsubscribe();
  }, [formMethods, initialValues, event, eventLoading, changesCount]);

  return changesCount;
};

export default useUpdateChangesCount;
